import './FilterProposta.css';
import DropdownFilter from '../dropdownFilter'; // ajuste o caminho conforme sua pasta
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

function FilterProposta({ isOpen, onClose, selectedCliente, setSelectedCliente, selectedProposta, setSelectedProposta, selectedArea, setSelectedArea, selectedServico, setSelectedServico, applyFilters }) {

    const [isInputFocused, setIsInputFocused] = useState(false);
    const [searchTerm, setSearchTerm] = useState('');
    const { t: tChat } = useTranslation('chat');

    const cliente = [
        { 'label': 'Público', 'value': 'publica' },
        { 'label': 'Privado', 'value': 'privada' }
    ];

    const proposta = [
        { 'label': 'Comercial', 'value': 'comercial' },
        { 'label': 'Técnica', 'value': 'tecnica' },
        { 'label': 'Comercial & Técnico', 'value': 'tecnico-comercial'}
    ];
    const areas = [
        { 'label': 'Edificações', 'value': 'Edificacoes' },
        { 'label': 'Desenvolvimento urbano', 'value': 'DesenvolvimentoUrbano' },
        { 'label': 'Transportes', 'value': 'Transportes' },
        { 'label': 'Energia', 'value': 'Energia' },
        { 'label': 'Saneamento', 'value': 'Saneamento' },
        { 'label': 'Irrigação', 'value': 'Irrigacao' },
        { 'label': 'Meio ambiente', 'value': 'MeioAmbiente' }
    ];
    const servico = [
        { 'label': 'Consultoria', 'value': 'Consultoria' },
        { 'label': 'Projeto', 'value': 'Projeto' },
        { 'label': 'Supervisão', 'value': 'Supervisao' },
        { 'label': 'Gerenciamento', 'value': 'Gerenciamento' }
    ];

    if (!isOpen) return null;

    
    // Função para fechar o modal ao clicar fora do conteúdo
    const handleClickOutside = (event) => {
        if (event.target.classList.contains('modal-overlay-filter')) {
            handleCloseModal();
        }
    };

    // Função para fechar o modal e redefinir estados
    const handleCloseModal = () => {
        onClose();
    };

    return (
        <div className='modal-overlay-filter' onClick={handleClickOutside}>
            <div className='modal-content-filter'>
                <p className='filter-title'>{tChat("filters")}</p>
                <img src="/imagens/x-red.svg" alt="" className='close-filter-modal' onClick={onClose} />

                <DropdownFilter
                    title="Tipo de Cliente"
                    placeholder="Tipo cliente"
                    options={cliente}
                    selectedValues={selectedCliente}
                    setSelectedValues={setSelectedCliente}
                    offsetTop={155}
                />

                <DropdownFilter
                    title="Tipo de Proposta"
                    placeholder="Tipo proposta"
                    options={proposta}
                    selectedValues={selectedProposta}
                    setSelectedValues={setSelectedProposta}
                    offsetTop={255}
                />

                <DropdownFilter
                    title="Área"
                    placeholder="Tipo área"
                    options={areas}
                    selectedValues={selectedArea}
                    setSelectedValues={setSelectedArea}
                    offsetTop={355}
                />

                <DropdownFilter
                    title="Serviço"
                    placeholder="Tipo serviço"
                    options={servico}
                    selectedValues={selectedServico}
                    setSelectedValues={setSelectedServico}
                    offsetTop={455}
                />

                <div className='central-button'>
                    <button className='gray-button'
                        onClick={() => {
                            applyFilters();
                            onClose(); // Fecha o modal após aplicar o filtro
                        }}>
                        {tChat("filter")}
                    </button>
                </div>
            </div>


        </div>
    )
}

export default FilterProposta